module.exports = __webpack_public_path__ + "media/application/images/ui/logo-maori-no-strap-665d7cb6e2ca9446ffdd5f8de5adfb13.png";